{
  "kernel": [
    -0.1510569006204605,
    0.003099137218669057,
    -0.15900340676307678,
    0.12011665850877762,
    -0.057891443371772766,
    0.17448867857456207,
    -0.1519913673400879,
    -0.216392382979393,
    0.01849386654794216,
    0.08350873738527298,
    0.0415165014564991,
    -0.19130760431289673,
    -0.02412683144211769,
    0.1770026534795761,
    0.19771528244018555,
    0.15793749690055847,
    -0.18685784935951233,
    -0.21318873763084412,
    0.021803032606840134,
    0.2766698896884918,
    -0.2022891491651535,
    -0.19871020317077637,
    -0.062331702560186386,
    0.12468022108078003,
    -0.03850237652659416,
    0.23285704851150513,
    -0.20334433019161224,
    0.10568003356456757,
    -0.044154614210128784,
    0.16032683849334717,
    -0.097268246114254,
    0.2038535475730896,
    0.15767402946949005,
    -0.2553205192089081,
    -0.03298241272568703,
    0.20971888303756714,
    -0.18130049109458923,
    -0.1410411298274994,
    -0.23118332028388977,
    0.0818193107843399,
    -0.036063436418771744,
    -0.20720984041690826,
    0.1990758776664734,
    0.12115491181612015,
    0.028838524594902992,
    -0.1845812201499939,
    -0.09672915935516357,
    0.17627084255218506,
    0.12805548310279846,
    0.14295729994773865,
    -0.09769488126039505,
    -0.0878496766090393,
    0.090189628303051,
    0.17109419405460358,
    0.015018670819699764,
    -0.06641951203346252,
    0.14793939888477325,
    0.1158759742975235,
    0.065831258893013,
    0.08582819253206253,
    -0.06274775415658951,
    0.15555059909820557,
    0.2657538950443268,
    -0.2174042910337448,
    0.1046232208609581,
    0.12131740152835846,
    0.16741815209388733,
    0.03342898190021515,
    0.0628320500254631,
    -0.04663894325494766,
    0.20362909138202667,
    -0.16750897467136383,
    0.22809770703315735,
    0.22724054753780365,
    0.05958077311515808,
    0.1812760829925537,
    0.23148435354232788,
    0.10202819108963013,
    0.21379992365837097,
    0.10552611947059631,
    -0.0886366218328476,
    -0.08518210053443909,
    -0.07742603123188019,
    0.07159686833620071,
    -0.18173736333847046,
    -0.012517287395894527,
    0.027471601963043213,
    -0.22150206565856934,
    -0.02851872704923153,
    0.17881149053573608,
    -0.241571307182312,
    -0.03936607763171196,
    0.0830262154340744,
    -0.008131483569741249,
    0.1173413097858429,
    0.07741665095090866,
    0.08158255368471146,
    0.14051733911037445,
    0.010661354288458824,
    -0.217979297041893,
    0.038329094648361206,
    0.10477270931005478,
    0.19431227445602417,
    -0.15812279284000397,
    -0.12212569266557693,
    -0.13973942399024963,
    -0.08511050790548325,
    0.19861717522144318,
    0.25849050283432007,
    -0.10043485462665558,
    -0.009156811982393265,
    0.14086908102035522,
    -0.05180893465876579,
    -0.041504260152578354,
    -0.1939041018486023,
    -0.1875675469636917,
    0.040047477930784225,
    -0.23016339540481567,
    -0.026636483147740364,
    -0.16322311758995056,
    -0.0862913429737091,
    0.15565387904644012,
    -0.21707843244075775,
    -0.12426704168319702,
    0.2106660008430481,
    -0.05380967631936073,
    0.12004779279232025,
    0.0693846195936203
  ],
  "bias": -0.0015675477916374803
}
